"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticThemes = void 0;
const GeneralConstants_1 = require("../Utilities/Constants/GeneralConstants");
exports.StaticThemes = [
    {
        Name: GeneralConstants_1.LIGHT_THEME,
        Description: 'Light Theme',
    },
    {
        Name: GeneralConstants_1.DARK_THEME,
        Description: 'Dark Theme',
    },
];
